import apiDownload from '@/services/api/modules/download'
export default {
  // 查询日加权平均价初始化列表
  getCostList: {
    url: '/amazonCost/queryWarehouseDailyCost',
    method: 'post',
    desc: '查询日加权平均价初始化列表'
  },

  // 查询所选日期缺失的SKU数量和货件计划
  queryMissingValue: {
    url: '/amazonCost/queryMissingValue',
    method: 'post',
    desc: '所选日期缺失的SKU数量和货件计划'
  },

  // 查询仓库的开始日期和结束日期
  queryWarehouseDateRange: {
    url: '/amazonCost/queryWarehouseDateRange',
    method: 'post',
    desc: '查询仓库的开始日期和结束日期'
  },

  // 期初成本初始化 - 下载初始成本商品表
  downloadInitialCostExcel(reqData) {
    apiDownload.fetchDownloadPostGeneric('/amazonCost/exportInitialCost', reqData)
  },

  // 期初成本初始化 - 导入初始成本商品表
  importInitialCostExcel: {
    url: '/amazonCost/importInitialCost',
    method: 'post',
    desc: '导入初始成本'
  },

  // 下载货件计划
  downloadReceiptCostExcel(reqData) {
    apiDownload.fetchDownloadPostGeneric('/amazonCost/exportReceiptCost', reqData)
  },

  // 发货补录
  importReceiptCostExcel: {
    url: '/amazonCost/importReceiptCost',
    method: 'post',
    desc: '发货补录'
  },

  // 计算每日加权成本前，校验初始成本和货件计划是否已维护
  checkDailyCostData: {
    url: '/amazonCost/checkDailyCostData',
    method: 'post',
    desc: '校验初始成本和货件计划'
  },

  // 计算日加权平均价结果
  calculateDailySkuCost: {
    url: '/amazonCost/calculateDailySkuCost',
    method: 'post',
    desc: '计算日加权平均价结果'
  },

  // 下载商品日平均价 & 下载成本价 - 按天调整模板
  downloadDailySkuCost(reqData) {
    apiDownload.fetchDownloadPostGeneric('/amazonCost/exportDailySkuCostList', reqData)
  },

  // 发货补录并重算
  importReceiptCostAndRecalculateExcel: {
    url: '/amazonCost/importReceiptCostAndRecalculate',
    method: 'post',
    desc: '发货补录'
  },

  // 下载商品日平均价 & 下载成本价 - 按天调整模板
  downloadRangeSkuCost(reqData) {
    apiDownload.fetchDownloadPostGeneric('/amazonCost/exportRangeSkuCost', reqData)
  },

  // 成本调整 - 按天导入
  importDailySkuCostExcel: {
    url: '/amazonCost/importDailySkuCost',
    method: 'post',
    desc: '成本调整 - 按天导入'
  },

  // 成本调整 - 按日期范围调整
  importRangeSkuCostExcel: {
    url: '/amazonCost/importRangeSkuCost',
    method: 'post',
    desc: '成本调整 - 按日期范围调整'
  },

  // 下载FBA订单
  exportFbaOrder(reqData) {
    apiDownload.fetchDownloadPostGeneric('/amazonCost/exportFbaOrder', reqData)
  },

  // 下载FBA进销存成本报表
  downloadFbaCost(reqData) {
    apiDownload.fetchDownloadPostGeneric('/amazonCost/exportFbaCost', reqData)
  },

  // 下载FBA进销存数量报表
  downloadFbaQuantity(reqData) {
    apiDownload.fetchDownloadPostGeneric('/amazonCost/exportFbaQuantity', reqData)
  },

  // FBA进销存报表 - 仓库数据更新至-日期
  queryFbaUpdatedDate: {
    url: '/amazonCost/queryFbaUpdatedDateV2',
    method: 'post',
    desc: '仓库数据更新至-日期'
  },

  // v 1.2 - 商品日平均价报表
  listDailySkuCost: {
    url: '/amazonCost/listDailySkuCost',
    method: 'post',
    desc: '日平均价报表'
  },
  // v 2.0 - FBA进销存数量列表
  listFbaQuantity: {
    url: '/fbaReport/listQuantity',
    method: 'post',
    desc: 'Fba进销存数量列表'
  },
  // FBA进销存数量总计
  listQuantityTotal: {
    url: '/fbaReport/listQuantityTotal',
    method: 'post',
    desc: 'Fba进销存数量总计'
  },
  // v 2.0 - FBA进销存成本列表-先进先出
  listFifoCost: {
    url: '/fbaReport/listFifoCost',
    method: 'post',
    desc: 'Fba进销存成本列表-先进先出'
  },
  // FBA进销存成本总计-先进先出
  listFifoCostTotal: {
    url: '/fbaReport/listFifoCostTotal',
    method: 'post',
    desc: 'Fba进销存成本列表-先进先出'
  },

  // v 2.0 - FBA进销存成本列表-固定值
  listFixedCost: {
    url: '/fbaReport/listFixedCost',
    method: 'post',
    desc: 'Fba进销存成本列表-固定值'
  },
  // FBA进销存成本总计-固定值
  listFixedCostTotal: {
    url: '/fbaReport/listFixedCostTotal',
    method: 'post',
    desc: 'Fba进销存成本总计-固定值'
  },

  // v 2.0 - FBA进销存成本列表-成本重算
  recalculateFixedCost: {
    url: '/fbaReport/recalculateFixedCost',
    method: 'post',
    desc: 'Fba进销存成本列表-成本重算'
  },

  // 先进先出 - 初始化
  FifoInitialize: {
    url: '/amazonFifo/initialize',
    method: 'post',
    desc: '先进先出初始化'
  },
  // 先进先出 - 查询先进先出列表筛选
  getFifoCondition: {
    url: '/amazonFifo/queryCondition',
    method: 'post',
    desc: '先进先出列表筛选项'
  },
  // 先进先出 - 查询先进先出列表
  getFifoList: {
    url: '/amazonFifo/queryFifoList',
    method: 'post',
    desc: '先进先出列表'
  },
  // 先进先出 - 查询先进先出总计
  getFifoListTotal: {
    url: '/amazonFifo/queryFifoListTotal',
    method: 'post',
    desc: '先进先出列表'
  },
  // 先进先出 - 导入初始化成本数
  importFifoInitialExcel: {
    url: '/amazonFifo/importFifoInitial',
    method: 'post',
    desc: '先进先出 - 导入初始化成本数'
  },
  // 先进先出 - 重算
  recalculate: {
    url: '/amazonFifo/recalculate',
    method: 'post',
    desc: '先进先出- 重算',
  },
  // 头程分摊 - 查询头程分摊列表
  FirstTripList: {
    url: '/amazonCost/pageShareFirstTripCost',
    method: 'post',
    desc: '头程分摊列表'
  },
  // 头程分摊 - 删除
  DelShareFirstTripCost: {
    url: '/amazonCost/delShareFirstTripCost',
    method: 'post',
    desc: '头程分摊删除'
  },
  // 头程分摊 - 导入
  ImportShipment: {
    url: '/amazonCost/importShipment',
    method: 'post',
    desc: '头程分摊导入'
  },
  // 头程分摊 - 删除导入记录
  DelImportById: {
    url: '/asyncImport/deleteById',
    method: 'post',
    desc: '头程分摊删除'
  },
  // 头程分摊 - 更新成本
  FirstTripUpdateCost: {
    url: '/amazonCost/updateCost',
    method: 'post',
    desc: '头程分摊-更新成本'
  },
}
